import { SavingsWithdrawDialogContentContainer } from './SavingsWithdrawDialogContentContainer'
import { Mode } from './types'
import { Token } from '@/domain/types/Token'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export type SavingsWithdrawDialogProps = CommonDialogProps & {
  mode: Mode
  savingsToken: Token
  chainId: number
}

function SavingsWithdrawDialog({ mode, savingsToken, chainId, open, setOpen }: SavingsWithdrawDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <SavingsWithdrawDialogContentContainer
          mode={mode}
          savingsToken={savingsToken}
          closeDialog={() => setOpen(false)}
          chainId={chainId}
        />
      </DialogContent>
    </Dialog>
  )
}

export const savingsWithdrawDialogConfig: DialogConfig<SavingsWithdrawDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: SavingsWithdrawDialog,
  name: 'SavingsWithdrawDialog',
}
